// extracted by mini-css-extract-plugin
export default {"main":"index_main__DU4-I","mainArea":"index_mainArea__tDcCl","isMobile":"index_isMobile__Xa0R9","operationArea":"index_operationArea__qTNVF"};